import { Action } from 'common/interfaces/root';
import { publishersSettingsActionTypes as T } from '../actions';

const initState: PublishersSettingsModule.AffiliateSettingsStore = {
  loading: true,
  error: null,
  data: null,
};

export default (
  state: PublishersSettingsModule.AffiliateSettingsStore = initState,
  { type, payload }: Action
): PublishersSettingsModule.AffiliateSettingsStore => {
  switch (type) {
    case T.GET_PUBLISHER_AFFILIATE:
      return { ...state, loading: true };

    case T.GET_PUBLISHER_AFFILIATE_SUCCESS:
      return { ...state, loading: false, data: payload.data };

    case T.GET_PUBLISHER_AFFILIATE_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
